export default {
  dashboard: 'لوحة التحكم',
  home: 'الرئيسية',
  titleCardAddPatient: 'ادخال معلومات المريض',
  edit: 'تعديل',
  title: 'العنوان',
  PatientCoverage: 'تغطية المريض',
  delete: 'حذف',
  AllowNegativeBalance: 'السماح بالرصيد السالب',
  birthDate: 'تاريخ الميلاد',
  dateOfEstablishment: 'تاريخ التأسيس',
  payableAccount: 'حساب الدفع',
  AdditionalPreviousExperiences: 'الخبرات السابقة',
  deletePractitionerSchedule: ' جدول جدول طبيب',
  practitionerName: 'اسم الطبيب',
  attendanceDate: 'تاريخ الحضور',
  AddAttandence: 'إضافة سجل حضور',
  Warehouses: 'المستودعات',
  Absent: 'غياب',
  selectTypeFormat: 'حدد نوع التنسيق',
  SalesFinance: 'الفواتير و الحسابات',
  add: 'اضافة',
  PayrollEntry: 'دخول الرواتب',
  AddPayrollEntry: 'اضافة دخول الرواتب',
  validateAttendance: 'تأكيد الحضور',
  Present: 'حاضر',
  OnLeave: 'في اجازة',
  HalfDay: 'نصف يوم',
  WorkFromHome: 'عمل منزلي',
  draft: 'مسودة',
  deleteAttandence: 'حذف الحضور',
  Edit: 'تعديل',
  approved: 'موافق',
  docstatus: 'الحالة',
  Attandence: 'الحضور',
  rejected: 'مرفوض',
  isPaid: 'مدفوع',
  EditLeaveAllocation: 'تعديل تخصيص الاغازه',
  EditAttandence: 'تعديل الحضور',
  earlyExit: 'خروج مبكر',
  warehouse: 'المستودع',
  leaveAllocation: 'تخصيص إجازه',
  values: 'القيم',
  primaryAddress: 'العنوان الرئيسي',
  typeName: 'اسم النوع',
  typeCode: 'كود النوع',
  downloadZatcaXML: 'تحميل XML ZATCA',
  GetZatcaDetails: 'حصول على تفاصيل ZATCA',
  typeCode: 'كود النوع',
  customAdditional: 'الاضافات المخصصه',
  downloadZatcaPdf: 'تحميل PDF ZATCA',
  totalLeavesAllocated: 'مجموع الاجازات المخصصه',
  DeleteLeaveAllocation: 'حذف تخصيص إجازه',
  AddLeaveAllocation: 'اضافة تخصيص إجازة',
  addLeaveAllocation: 'اضافة تخصيص إجازة',
  AddStockEntry: 'اضافة حركة مخزون',
  returnPurchaseInvoice: 'ارجاع فاتورة مشتريات',
  TotalHolidays: 'اجمالي العطلات',
  debitNote: 'إشعار دائن',
  IdNumber: 'رقم الهوية',
  EditHoliday: 'تعديل العطلة',
  CommercialRegistryNumber: 'رقم السجل التجاري',
  CustomerID: 'رقم العميل',
  holidayListName: 'اسم قائمة العطلات',
  holidayDate: 'تاريخ العطلة',
  weeklyOff: 'العطلات الاسبوعية',
  AddHoliday: 'اضافة العطلات',
  HolidayList: 'قائمة العطلات',
  DeleteHoliday: 'حذف العطلة',
  annualAllocation: 'التخصيص السنوي',
  warehouseName: 'اسم المستودع',
  addMaterialWarehouse: 'اضافة مستودع مواد',
  Purchase: 'المشتريات',
  AcceptedQuantity: 'الكمية المقبولة',
  Details: 'التفاصيل',
  salaryDeduction: 'حسومات على الراتب',
  RejectedQuantity: 'الكمية المرفوضة',
  symptoms: 'الاعراض',
  undefined: 'غير محدد',
  materialRequest: 'طلب مواد',
  MaterialWarehouses: 'مستودعات المواد',
  materialRequestType: 'نوع الطلب',
  RecieptDetails: 'تفاصيل الايصال',
  DeletetheMaterialWarehouse: 'حذف المستودع',
  SalaryDetailes: 'تفاصيل الراتب',
  owner: 'المالك',
  ExitDetailes: 'تفاصيل الخروج',
  EducationDetailes: 'تفاصيل التعليم',
  is_paid: 'مدفوع',
  employeeDetails: 'تفاصيل الموظف',
  employeeContactDetails: 'تفاصيل التواصل للموظف',
  employeePersonalDetails: 'التفاصيل الشخصيه للموظف',
  deleteExpenseClaim: 'حذف مطالبه نفقات',
  returnInvoiceId: ' رقم فاتورة الاسترجاع',
  scheduleDate: 'تاريخ الجدوله',
  expenseClaim: 'مطالبة نفقات',
  addExpenseClaim: 'إضافة مطالبة نفقات',
  editWarehouse: 'تعديل مستودع',
  DeletetheWarehouse: 'حذف مستودع',
  editSupplierGroup: 'تعديل مجموعة المورد',
  SupplierNameInArabic: 'اسم المورد باللغة العربية',
  SupplierGroup: 'مجموعة المورد',
  currencyAndPriceList: 'قائمة العملات والأسعار',
  accountingDimensions: 'مقاييس المحاسبة',
  ParentGroup: 'المجموعة الرئيسية',
  ignorePricingRule: 'تجاهل قاعدة الاسعار',
  ParentWarehouse: 'المستودع الرئيسي',
  All: 'الكل',
  addSupplier: 'اضافة مورد',
  download: 'تحميل',
  downloadPdf: 'تحميل PDF',
  DeletetheSupplier: 'حذف المورد',
  addWarehouse: 'اضافة مستودع',
  Reconcile: 'تسوية',
  supplierType: 'نوع المورد',
  Individual: 'فرد',
  bankAccount: 'حساب البنك',
  GeneralLedger: 'دفتر اليومية',
  includeDefaultBookEntries: 'تشمل إدخالات الكتاب الافتراضية',
  default: 'افتراضي',
  EditSalarySlip: 'تعديل مسير الراتب',
  includeDimensions: 'تضمين المقاييس',
  defaultCurrency: 'العملة الافتراضيه ',
  bodyMap: 'خريطة الجسم',
  getPDF: 'تحميل PDF',
  addSupplierGroup: 'اضافة مجموعة المورد',
  DeletetheSupplierGroup: 'حذف مجموعة المورد',
  VoucherNo: 'رقم الفاتورة',
  netPay: 'صافي الدفع',
  salarySlip: 'مسير الوراتب',
  addSalarySlip: 'اضافة مسير الراتب',
  paymentDays: 'الأيام المدفوعه',
  mainCostCenter: 'مركز التكلفة الرئيسي',
  percentageError: 'النسبة المئوية يجب ان تكون بين 0 و 100',
  Number: 'رقم',
  totalCredit: 'اجمالي الدائن',
  totalDebit: 'اجمالي المدين',
  addItemPrice: 'اضافة سعر الصنف',
  ValidFrom: 'تاريخ الانتهاء',
  editItemPrice: 'تعديل سعر الصنف',
  branch: 'الفرع',
  approver: 'المسؤول',
  ExpenseApprovers: 'موافقات المصروف',
  addDesignation: 'اضافة وظيفة',
  contractEndDate: 'تاريخ الانتهاء',
  expenseApprover: 'مسؤول موافقة المصروفات',
  DateOfRetirement: 'تاريخ الانتهاء',
  leaveApprover: 'مسؤول موافقة الإجازات',
  followViaEmail: 'متابعة عبر البريد الالكتروني',
  LeaveStatus: 'حالة الاجازة',
  MainCostCenter: 'مركز التكلفة الرئيسي',
  messageErorrReconcileTwo:
    'تم تعديل إدخال الدفع بعد سحبه. يرجى سحبه مرة أخرى.',
  BranchCode: 'رمز الفرع',
  Relation: 'العلاقة',
  cellNumber: 'رقم الجوال',
  PersonToBeContacted: 'اسم قريب للتواصل',
  EmergencyPhoneNumber: 'رقم التليفون للطوارئ',
  PerferredContactEmail: 'البريد الالكتروني للقريب',
  currentAddress: 'العنوان الحالي',
  PersonalEmail: 'البريد الالكتروني',
  CompanyEmail: 'البريد الالكتروني للشركة',
  ItemPrice: 'سعر الصنف',
  BankAccountNo: 'رقم الحساب البنكي',
  addBank: 'اضافة بنك',
  AddCostCenterAllocation: 'اضافة تخصيص مركز التكلفة',
  EditBank: 'تعديل بنك',
  AddBankAccount: 'اضافة حساب بنكي',
  EditBankAccount: 'تعديل حساب بنكي',
  salesInfo: 'معلومات المبيعات',
  accumulatedDepreciationAccount: 'حساب التخلف المؤقت',
  defaultCurrency: 'عملة الافتراضية',
  totalMonthlySales: 'اجمالي المبيعات الشهرية',
  financialDetails: 'تفاصيل المالية',
  monthlySalesTarget: 'هدف المبيعات الشهرية',
  IBAN: 'رقم الايبان',
  totalMonthlySales: 'اجمالي المبيعات الشهرية',
  monthlySalesTarget: 'هدف المبيعات الشهرية',
  defaultCurrency: 'عملة الافتراضية',
  swiftNumber: 'رقم Swift',
  voucherType: 'نوع الفاتورة',
  total_deduction: 'اجمالي الخصم',
  Payments: 'الدفعات',
  abbr: 'الاسم العربي',
  salary_component: 'نوع الراتب',
  year_to_date: 'المبلغ الكلي حتى الان',
  salary_component: 'نوع الراتب',
  total_earnings: 'اجمالي الدخل',
  net_pay: 'المبلغ الصافي',
  total_in_words: 'المبلغ بالكلمات',
  rounded_total: 'المبلغ الصافي',
  gross_year_to_date: 'المبلغ الكلي حتى الان',
  gross_pay: 'المبلغ الكلي',
  Suppliers: 'الموردين',
  topSuppliers: 'افضل الموردين',
  TopItemSold: 'الصنف الاكثر مبيعا',
  CountPo: 'عدد الطلبات',
  addStatementOfAccount: 'اضافة كشف حساب',
  state: 'الولاية',
  TopItemPurchased: 'الصنف الاكثر شراءا',
  StatementOfAccount: 'كشف الحساب',
  AddStatementOfAccount: 'اضافة كشف حساب',
  EditStatementOfAccount: 'تعديل كشف حساب',
  taxId: 'الرقم الضريبي',
  Inventory: 'المخزون',
  LinkedDocs: 'مستندات مرتبطة',
  releaseDate: 'تاريخ الاصدار',
  Unlink: 'الغاء الارتباط',
  GetLinkedDocs: 'المستندات المرتبطة',
  holdType: 'نوع العملية',
  Invoices: 'الفواتير',
  ENTERRECONCILIATION: 'تسوية الفواتير',
  InvoicesList: 'قائمة الفواتير',
  PaymentsList: 'قائمة الدفعات',
  allocatedAmount: 'المبلغ المخصص',
  differenceAmount: 'المبلغ المتبقي',
  ENTERALLOCATEDAMOUNT: 'ادخال المبلغ المحجوز',
  Reconcillation: 'التسوية',
  exchangeRate: 'سعر الصرف',
  invoiceDate: 'تاريخ الفاتورة',
  outstandingAmount: 'المبلغ المتبقي',
  AddComplaint: 'اضافة شكوى',
  complaint: 'شكوى',
  allocatedAmountGreaterThanOutstanding:
    'المبلغ المحجوزة اكبر من المبلغ المتبقي',
  ENTERSSYMPTOMS: 'ادخال الاعراض',
  symptom: 'عرض',
  ENTERCOMPLAINT: 'ادخال الشكوى',
  insurancePolicy: 'تغطية بنك الضمان',
  complaints: 'الشكاوي',
  addSymptoms: 'اضافة أعراض',
  todayAppointments: 'مواعيد اليوم',
  tomorrowAppointments: 'مواعيد الغد',
  addPatientInsuranceCoverage: 'اضافة بنك الضمان',
  illnesses: 'الامراض',
  EDITINSURANCECLAIMINFORMATION: 'تعديل معلومات الطلب',
  ENTERINSURANCECLAIMINFORMATION: 'ادخال معلومات الطلب',
  customZatcaExportInvoice: 'فاتورة تصدير طرف ثالث مخصصة من ',
  customSelfBilledInvoice: 'فاتورة بنك الضمان مخصصة من ',
  patientID: 'الهوية',
  custom_user_invoice_number: 'رقم الفاتورة',
  customBuyerIdType: 'نوع الهوية المشتري ',
  custom_vat_registration_number: 'رقم التسجيل الضريبي',
  custom_zatca_tax_category: 'فئة ضريبة طرف ثالث',
  custom_submit_line_item_discount_to_zatca:
    'اضافة خصم للصنف في فاتورة طرف ثالث',
  custom_zatca_status: 'حالة فاتورة طرف ثالث',
  custom_zatca_tax_category: 'فئة ضريبة طرف ثالث',
  custom_b2c: 'B2C',
  custom_uuid: 'الرقم التعريفي',
  custom_zatca_discount_reason: 'السبب المستفيد من التخفيض',
  custom_exemption_reason_code: 'السبب المستفيد من التخفيض',
  custom_zatca_discount_reason_code: 'سبب التخفيض ',
  customBuyerId: 'الهوية المشتري',
  customZatcaThirdPartyInvoice: 'فاتورة طرف ثالث مخصصة من ',
  customZatcaNominalInvoice: 'فاتورة نومينال مخصصة من ',
  ItemEligibilityInformation: 'معلومات تحديد التغطية',
  modeOfApproval: 'طريقة الاعتماد',
  ItemEligibility: 'تحديد التغطية',
  coverage: 'التغطية',
  addItemEligibility: 'اضافة تحديد التغطية',
  discount: 'الخصم',
  templateDt: 'نموذج DT',
  templateDn: 'نموذج DN',
  paymentErrorReason: 'سبب خطاء الدفع',
  voucher: 'السند',
  Welcome: 'مرحبا',

  password: 'كلمة المرور',
  Search: 'بحث',
  KeepMeConnected: 'حفظ الاتصال',
  customer: 'العميل',
  Login: 'تسجيل الدخول',
  RestorePassword: 'استعادة كلمة المرور',
  AllRightsReservedDHAYAELALDAN: 'جميع الحقوق محفوظة DHAYAELALDAN',
  EnterYourPassword: 'ادخل كلمة المرور',
  username: 'اسم المستخدم',
  PleaseInputYourPassword: 'الرجاء ادخال كلمة المرور',
  email: 'البريد الالكتروني',
  EnterYourEmail: 'ادخل البريد الالكتروني',
  PleaseInputYourUsername: 'الرجاء ادخال اسم المستخدم',
  coverage: 'التغطية',
  InvalidEmail: 'البريد الالكتروني غير صحيح',
  PleaseInputYourEmail: 'الرجاء ادخال البريد الالكتروني',
  Manual: 'يدوي',
  ReceiptInformation: 'معلومات الايصال',
  totalInvoiceAmount: 'اجمالي المبلغ',
  invoice: 'فاتورة',
  invoices: 'الفواتير',
  Automatic: 'تلقائي',
  validFrom: 'صالح من تاريخ',
  MaterialReceipt: 'ايصال المواد',
  RECEIPTENTRYINFORMATION: 'معلومات ادخال الايصال',
  itemCode: 'كود الصنف',
  EnterIllnessInformation: 'ادخال معلومات الامراض',
  EditIllnessInformation: 'تعديل معلومات الامراض',
  NameEnglish: 'الاسم الانجليزي',
  Payment: 'دفع',
  insurancePlan: 'بنك الضمان',
  Overview: 'نظرة عامة',
  editPatient: 'تعديل المريض',
  active: 'مفعل',
  userId: 'اسم المستخدم',
  customIdExpiryDate: 'تاريخ انتهاء الهوية ',
  inactive: 'غير مفعل',
  suspended: 'معلق',
  left: 'مغادر ',
  customIdNumber: 'رقم الهوية ',
  sellingPriceList: 'قائمة البيع',
  PleaseEnterValidData: 'ادخل بيانات صحيحة',
  CustomNationality: 'الجنسية',
  isActive: 'مفعل',
  TotalPatients: 'عدد المرضى الكلي',
  cancelPatientInsurancePolicy: 'الغاء عقد بنك الضمان',
  changeStatus: 'تغيير الحالة',
  thisMonth: 'هذا الشهر',
  cancelPayorContract: 'الغاء عقد الدفع',
  Today: 'اليوم',
  CreditInvoice: 'اشعار دائن',
  Cancel: 'الغاء',
  LeaveType: 'إجازة',
  CancelInvoice: 'الغاء الفاتورة',
  DeleteLeaveType: 'حذف الإجازة',
  EditLeavePolicy: 'تعديل سياسة الإجازة',
  AddLeavePolicy: 'أضف سياسة الإجازة',
  effectiveFrom: 'متاحة من',
  effectiveTo: 'متاحة حتى',
  leavePolicy: 'سياسة الإجازة',
  DeleteLeavePolicy: 'حذف سياسة الإجازة',
  CancelPayment: 'الغاء الدفع',
  Partiallypaidleave: 'إجازة مدفوعة جزئياً',
  fractionOfDailyWagePerLeave: 'النسبة المئوية للراتب يومي',
  leaveTypeName: 'اسم الإجازة',
  AddLeaveType: 'اضافة أجازة',
  EditLeaveType: 'تعديل أجازة',
  maxLeavesAllowed: 'الحد الأقصى للاجازات',
  applicableAfter: 'مستحقه بعد',
  maxContinuousDaysAllowed: 'الحد الأقصى للأيام المتواصلة',
  Areyouwithoutsalary: 'اجازه بدون راتب',
  Isdeportationallowed: 'هل يسمح بالمغادرة',
  Earnedleave: 'الاجازات المكتسبة',
  expireCarryForwardedLeavesAfterDays: 'انتهاء صلاحية الأيام المرحّلة بعد',
  maximumCarryForwardedLeaves: 'الحد الأكثر صلاحية المرحّلة',
  Includedholidaysandvacations: 'تضمين العطلات والأجازات',
  AllowNegative: 'السماح بالنقص',
  Week: 'الاسبوع',
  Month: 'الشهر',
  Search: 'بحث',
  Quarter: 'ربع سنوي',
  HalfYear: 'نصف سنوي',
  Year: 'سنة',
  Reset: 'اعادة',
  SourceWarehouse: 'مستودع المصدر',
  TargetWarehouse: 'مستودع الهدف',
  EditStockEntry: 'تعديل أدخال المخزون',
  toWarehouse: 'الى المخزن',
  fromWarehouse: 'من المخزن',
  purchaseReturn: 'مرتجع الشراء',
  AdditionalCosts: 'التكاليف الاضافية',
  Return: 'مرتجع',
  value: 'القيمة',
  AddEmployee: 'اضافة موظف',
  UpdateEmployee: 'تعديل موظف',
  HR: 'HR',
  Employees: 'الموظفين',
  dateOfJoining: 'تاريخ الانضمام',
  materialReceipt: 'مواصفات الايصال',
  totalAdditionalCosts: 'التكاليف الاضافية الكلية',
  totalAmount: 'المبلغ الكلي',
  totalIncomingValue: 'القيمة الواردة الكلية',
  valueDifference: 'المبلغ المتبقي',
  unallocated_amount: 'المبلغ الغير مخصص',
  total_allocated_amount: 'المبلغ المخصص',
  stockEntryType: 'نوع أدخال المخزون',
  totalIncomingValue: 'القيمة الواردة الكلية',
  totalOutgoingValue: 'القيمة الصادرة الكلية',
  DeletetheStockEntry: 'حذف أدخال المخزون',
  differenceAmount: 'المبلغ المتبقي',
  DateOfBirth: 'تاريخ الميلاد',
  Year: 'السنة',
  StockEntry: 'إدخال المخزون',
  AddStockEntry: 'اضافة أدخال المخزون',
  TotalExpenses: 'المصاريف الكلية',
  PaymentsEntry: 'دخول المدفوعات',
  ViewAll: 'عرض الكل',
  NewPatients: 'مرضى جديدة',
  LabTests: 'اختبارات المختبر',
  ThisWeek: 'هذا الاسبوع',
  NameArabic: 'الاسم العربي',
  TotalIncome: 'الدخل الكلي',
  Deletetheservice: 'حذف الخدمة',
  firstName: 'الاسم الاول',
  addLabItems: 'اضافة خدمات للمختبر',
  areYouSure: 'هل انت متاكد؟',
  editService: 'تعديل الخدمة',
  DeletetheItem: 'حذف العنصر',
  editLabItems: 'تعديل خدمات المختبر',
  editItems: 'تعديل العناصر',
  middleName: 'الاسم الوسط',
  addtems: 'اضافة العناصر',
  deductions: 'الخصومات',
  addAnAppointment: 'اضافة موعد',
  addAnEncounter: 'فتح الموعد',
  SaveDraft: 'حفظ المسودة',
  Save: 'حفظ',
  SaveSubmit: 'حفظ وإرسال',
  lastName: 'الاسم الاخير',
  Inventory: 'المخزون',
  editPractitioner: 'تعديل الطبيب',
  searchPatient: 'بحث عن مريض',
  patientName: 'اسم المريض',
  departmentName: 'اسم القسم',
  custom_account: 'حساب مخصص',
  gender: 'الجنس',
  medialHistory: 'التاريخ الطبي و الادويه المستخدمه حاليا',
  settings: 'الاعدادات',
  Healthcare: 'الرعاية الصحية',
  AddDiagnosis: 'اضافة تشخيص',
  services: 'الخدمات',
  fixedAsset: 'اصناف ثابتة',
  zeroRated: 'غير محدد',
  exempt: 'معفى',
  maxDiscount: 'الحد الاقصى للخصم',
  grantCommission: 'منح عمولة مبيعات',
  isSalesItem: 'يمكن بيع الصنف',
  deliveredBySupplier: 'تم التوصيل من قبل المورد',
  allowNegativeStock: 'مسموح بالمخزون السالب',
  isExempt: 'معفى',
  salesUom: 'وحدة البيع',
  noOfMonths: 'عدد الشهور',
  isPurchaseItem: 'يمكن شراء الصنف',
  deferredExpense: 'مصاريف غير محددة',
  addService: 'اضافة خدمة',
  CRNumber: 'رقم السجل التجاري',
  purchaseOrder: 'طلب شراء',
  blockSupplier: 'حظر المورد',
  returnedQty: 'الكمية المرتجعة',
  billedAmt: 'المبلغ المباع',
  minOrderQty: 'الكمية الادنى للطلب',
  projectedQty: 'الكمية المتوقعة',
  landedCostVoucherAmount: 'تكاليف الشحن و التفريغ',
  AddAccountPeriod: 'اضافة فترة حسابية',
  ProfitLoss: 'الربح والخسائر',
  CashFlow: 'تدفق النقدي',
  periodName: 'اسم الفترة',
  accountPayable: 'الحسابات المدفوعة',
  BalanceSheet: 'التحليل الرصيدي',
  ConsolidatedFinancialStatement: 'التحليل الرصيدي',
  accountReceivable: 'الحسابات المستحقة',
  accountsReceivableSummary: 'ملخص الحسابات المستحقة',
  AccountPeriod: 'فترة الحساب',
  actualQty: 'الكمية التي تم طلبها',
  AccountPeriodInformation: 'معلومات فترة الحساب',
  closedDocuments: 'ايقاف العمليات على:',
  serviceStartDate: 'تاريخ بداية الخدمة',
  stockQty: 'الكمية الحالية',
  serviceEndDate: 'تاريخ نهاية الخدمة',
  RescheduleAppointment: 'إعادة جدولة الموعد',
  medicalDepartment: 'القسم الطبي',
  AppointmentDuration: 'مدة الموعد',
  deferredRevenueAccount: 'حساب الإيرادات المؤجله',
  material: 'المادة',
  transactionDate: 'تاريخ المعاملة',
  scheduleDate: 'تاريخ الجدولة',
  setWarehouse: 'تعيين المستودع',
  fileNumber: 'رقم الملف',
  MaterialTransfer: 'نقل المادة',
  MaterialIssue: 'تسليم المادة',
  Manufacture: 'تصنيع',
  patientCareType: 'نوع رعاية المريض',
  titleCardAddPractitioner: 'ادخال معلومات الطبيب',
  createPractitioner: 'اضافة الطبيب',
  editPractitioner: 'تعديل الطبيب',
  healthcarePractitioner: 'الطبيب',
  submit: 'اضافة',
  Specialty: 'التصنيف',
  contract_type: 'نوع العقد',
  action: 'العمليات',
  practitioner: 'الطبيب',
  practitioners: 'الاطباء',
  Single: 'اعزب/اعزبة',
  addPatient: 'اضافة مريض',
  GetLastEncounters: 'الحجوزات الاخيرة',
  GetLastInvoices: 'الفواتير الاخيرة',
  InternalSend: 'تحويل داخلي',
  Areyousuretodeletethislabtest: 'هل انت متاكد من حذف هذا الاختبار؟',
  editEncounter: 'تعديل الحجز',
  Married: 'متزوج/متزوجة',
  SearchLabTests: 'بحث عن اختبارات المختبر',
  DeletethePatient: 'حذف المريض',
  AddService: 'اضافة خدمة',
  editLabTest: 'تعديل الاختبار',
  searchItems: 'بحث عن عناصر',
  DeletetheLabTest: 'حذف الاختبار',
  EncounterComment: 'تعليق الحجز',
  TodoList: 'قائمة المهام',
  ItemPriceReport: 'تقرير سعر العناصر',
  EditTask: 'تعديل المهمة',
  showTask: 'عرض المهمة',
  SubmittheEncounter: 'ارسال الحجز ؟',
  AreyousuretobesubmitthisEncounter: 'هل انت متاكد من ارسال هذا الحجز؟',
  searchEncounter: 'بحث عن حجز',
  Areyousuretodeletethispatient: 'هل انت متاكد من حذف هذا المريض؟',
  DeletetheEncounter: 'حذف الحجز؟',
  newPassword: 'كلمة المرور الجديدة',
  deskTheme: 'المظهر',
  priority: 'الاولوية',
  AssignTo: 'تعيين ل',
  AssignTask: 'تعيين مهمة',
  AreyousuretodeletethisEncounter: 'هل انت متاكد من حذف هذا الحجز؟',
  StockAnalysisReport: 'تقرير تحليل المخزون',
  PurchaseAnalytics: 'تحليل المشتريات',
  logoutAllSessions: 'تسجيل الخروج من جميع الجلسات',
  Divorced: 'مطلق/مطلقة',
  appointments: 'الزيارات',
  Areyousuretodeletethispractitioner: 'هل انت متاكد من حذف هذا الطبيب؟',
  Widow: 'أرمل/أرملة',
  DeletethePractitioner: 'حذف الطبيب',
  phoneNumber: 'رقم الهاتف',
  email: 'البريد الالكتروني',
  DeletetheAppointment: 'حذف الموعد',
  Print: 'طباعة',
  Areyousuretodeletethisappointment: 'هل انت متاكد من حذف هذا الموعد؟',
  patientFileNumber: 'رقم الملف',
  searchAppointments: 'بحث عن زيارات',
  printLanguage: 'طباعة اللغة',
  parentDepartment: 'القسم الرئيسي',
  CustomerAddress: 'عنوان العميل',
  searchDepartment: 'بحث عن قسم',
  bloodGroup: 'فصيلة الدم',
  addDepartment: 'اضافة قسم',
  editDepartment: 'تعديل القسم',
  deleteDepartment: 'حذف القسم',
  financialDetails: 'تفاصيل المالية',
  addPractitionerSchedule: 'اضافة جدول الطبيب',
  reports: 'تفضيل التقارير',
  addEncounter: 'اضافة حجز',
  patientHistory: 'تاريخ المريض',
  occupation: 'الوظيفة',
  patientInformation: 'معلومات المريض',
  Root: 'الجذر',
  image: 'صورة',
  encounterDate: 'تاريخ الحجز',
  encounterID: 'رقم الحجز',
  encounterTime: 'وقت الحجز',
  Upload: 'تحميل',
  Country: 'الجنسيه',
  country: 'الدولة',
  AddSupplierGroup: 'اضافة المورد',
  editSupplier: 'تعديل المورد',
  NameInArabic: 'الاسم بالعربي',
  NameInEnglish: 'الاسم بالانجليزي',
  requestingDepartment: 'القسم المطلوب',
  mobile: 'رقم الجوال',
  time: 'وقت',
  age: 'العمر',
  male: 'ذكر',
  Crown: 'تاج',
  Tilts: 'جذر',
  AddIllness: 'اضافة الامراض',
  appointmentDate: 'تاريخ الزيارة',
  appointmentTime: 'وقت الزيارة',
  Missing: 'مفقود',
  Ext: 'تحويلة',
  OVR: 'الإجمالي',
  NYE: 'ناي',
  department: 'القسم',
  employmentType: 'نوع الوظيفة',
  reportsTo: 'المدير المباشر',
  appointmentType: 'مدة الزياره',
  maritalStatus: 'الحالة الزوجية',
  Duration: 'مدة الزيارة ',
  allowbookingfor: 'السماح بالحجز',
  designation: 'المسمى الوظيفي',
  addBranch: 'اضافة فرع',
  employeeName: 'اسم الموظف',
  deleteBranch: 'حذف الفرع',
  EditBranch: 'تعديل الفرع',
  Branch: 'الفرع',
  deleteDesignation: 'حذف الوظيفة',
  EditDesignation: 'تعديل الوظيفة',
  AddAppointmentDuration: 'اضافة مدة الزيارة ',
  patient: 'المرضى',
  status: 'الحالة',
  addAppointment: 'اضافة زيارة',
  female: 'انثى',
  customers: 'العملاء',
  date: 'تاريخ الميلاد ',
  address: 'العنوان',
  type: 'النوع',
  addAddress: 'اضافة عنوان',
  is_primary_address: 'العنوان الرئيسي',
  EditAddress: 'تعديل العنوان',
  nieghborhood: 'الحي',
  address_title: 'عنوان',
  Accounts: 'الحسابات',
  SubmitToZatca: 'ارسال الى زاتكا',
  city: 'المدينة',
  charge_item: 'الخدمات',
  is_shipping_address: 'عنوان الشحن',
  address_in_arabic: 'عنوان بالعربي',
  custom_buiding_number: 'رقم المبنى',
  custom_area: 'المنطقة',
  op_consulting_charge: 'رسوم الكشفيه',
  ClaimsReceivableAccount: 'حساب المطالبات المستحقة',
  identificationNumber: 'رقم الهوية',
  company: 'الشركة',
  expenseAccount: 'حساب المصروفات',
  messageErorrReconcile:
    'هناك خطأ في توزيع المبلغ المخصص. تأكد من أن المبلغ المخصص لا يتجاوز المبلغ المتبقي للدفع.',
  AccountsPayable: 'حساب المستحق الدفع',
  addInsurancePayor: 'اضافة مقدم التأمين',
  city: 'المدينة',
  Debit: 'مدين',
  receivedQty: 'الكميه المستلمه',
  Rate: 'السعر',
  Credit: 'دائن',
  practitionerSchedule: 'مواعيد الطبيب',
  orderedQty: 'الكميه المطلوبه',
  RejectedClaimsExpenseAccount: 'حساب نفقات المطالبات المرفوضة',
  EnterInsurancePayorInformation: 'ادخال معلومات مقدم التأمين',
  InsurancePayorInformation: 'معلومات مقدم التأمين',
  InsurancePayorName: 'اسم مقدم التأمين',
  InsuranceClaimCreditDays: 'عدد اليوميات المطالبة',
  insurancePayor: 'مستشفى التأمين',
  practitionerName: 'اسم الطبيب',
  practitionerNo: 'رقم الطبيب',
  open: 'فتح الموعد',
  openStatus: 'مفتوح',
  checkedOut: 'تسجيل الخروج',
  checkIn: 'تسجيل الدخول',
  dateEnd: 'تاريخ الانتهاء',
  priceListRate: 'سعر الوحدة',
  DefaultPriceList: 'قائمة الاسعار الافتراضية',
  startDate: 'تاريخ البدء',
  pending: 'قيد الانتظار',
  validUpto: 'صالح حتى',
  medicalDepartment: 'القسم الطبي',
  applyPutawayRule: 'تطبيق قاعدة التوزيع',
  isReturn: 'المرتجع',
  postingTime: 'وقت النشر',
  setPostingTime: 'تعيين وقت النشر',
  PriceList: 'قائمة الاسعار',
  receiptDocumentType: 'نوع المستند',
  receiptDocument: 'المستند',
  purpose: 'الغرض',
  PolicyNumber: 'رقم السياسة',
  repayUnclaimedAmountFromSalary: 'خصم المبالغ المتبقيه من الراتب',
  postingDate: 'تاريخ القيد',
  InsurancePlan: 'خطة التأمين',
  AddPatientInsurancePolicy: 'اضافة بوليصة التأمين',
  DeletethePatientInsurancePolicy: 'حذف بوليصة التأمين',
  DeletetheInsurancePayor: 'حذف مقدم التأمين',
  InsurancePayor: 'مقدم التأمين',
  AddInsurancePayor: 'اضافة مقدم التأمين',
  InsurancePayorEligibilityPlanInformation: 'معلومات خطة التأمين',
  eligibilityPlan: 'خطة الاهتمام',
  buying: 'الشراء',
  selling: 'البيع',
  priceList: 'قائمة الاسعار',
  UnitMeasure: 'وحدة القياس',
  DeleteUnitMeasure: 'حذف الوحدة',
  unitMeasureName: 'اسم الوحدة',
  mustBeWholeNumber: 'يجب ان يكون عدد صحيح',
  decimalNumber: 'عدد عشري',
  wholeNumber: 'عدد صحيح',
  addUnitMeasure: 'اضافة وحدة',
  editUnitMeasure: 'تعديل وحدة',
  priceListName: 'اسم قائمة الاسعار',
  editPriceList: 'تعديل قائمة الاسعار',
  addPriceList: 'اضافة قائمة الاسعار',
  enabled: 'مفعل',
  disabled: 'غير مفعل',
  InsurancePlanName: 'اسم خطة التأمين',
  addEligibilityPlan: 'اضافة خطة الاهتمام',
  addMaterial: 'اضافة مادة',
  SearchInsurancePayor: 'بحث عن مقدم التأمين',
  PatientInsurancePolicy: 'بوليصة التأمين',
  ENTERPATIENTINSURANCEPOLICYINFORMATION: 'ادخل معلومات بوليصة التأمين',
  outPatientCharge: 'مرتجعات الخدمات',
  status: 'الحالة',
  Activated: 'مفعلة ',
  DeletePriceList: 'حذف قائمة الاسعار',
  DeleteEmployee: 'حذف الموظف',
  Deactivated: 'معطلة',
  labTestInformation: 'معلومات الفحص',
  eNTERLABTESTINFORMATION: 'ادخل معلومات الفحص',
  testTemplate: 'قالب الفحص',
  select_name: 'اختر الاسم',
  coverageAmount: 'مبلغ التغطية',
  qtyInvoiced: 'الكمية المفوضة',
  onHold: 'تجميد',
  discountType: 'نوع الخصم',
  approved: 'موافق',
  rejected: 'مرفوض',
  cancelled: 'ملغي',
  editLeaveApplication: 'تعديل الطلب',
  approvedAmount: 'المبلغ الموافق عليه',
  pendingAmount: 'المبلغ المعلق',
  claimedAmount: 'المبلغ المستحق',
  IncomingPaymentEntry: 'دفعة واردة',
  OutgoingPaymentEntry: 'دفعة صادرة',
  totalSalesOrderCount: 'عدد الطلبات المباعة',
  paidAmount: 'المبلغ المدفوع',
  returnAmount: 'المبلغ المرجوع',
  accountManager: 'مدير الحسابات',
  advanceAccount: 'حساب الخصم',
  discountAmount: 'مبلغ الخصم',
  coverageAmountInvoiced: 'مبلغ التغطية المفوض',
  patientPayable: 'المبلغ المستحق',
  itemEligibility: 'التأمينات الصنف',
  GoodMorning: 'صباح الخير',
  againstExpenseAccount: 'حساب نفقات المخزون',
  dueDate: 'تاريخ الاستحقاق',
  companyTrn: 'الرقم الضريبي للشركة',
  creditTo: 'الحساب الذي ستُخصم منه المبالغ',
  paymentAccount: 'حساب الدفع',
  invoicePortion: 'نسبة الفاتورة',
  SubmitBankEntry: 'ارسال القيد',
  paymentAmount: 'مبلغ الدفع',
  fromDate: 'من تاريخ',
  basePaymentAmount: 'مبلغ الدفع الاساسي',
  outstanding: 'متبقي',
  discountedAmount: 'مبلغ الخصم',
  PolicyExpiryDate: 'تاريخ انتهاء البوليصة',
  addPractitioner: 'اضافة طبيب',
  internal: 'داخلي',
  InsuranceClaim: 'مطالبة التأمين',
  addInsuranceClaim: 'اضافة مطالبة التأمين',
  confirm: 'تأكيد',
  Patient: 'المريض',
  deliveryDate: 'تاريخ التسليم',
  InsuranceClaimAmount: 'مبلغ مطالبة التأمين',
  Patients: 'المرضى',
  cancelJournal: 'الغاء القيد',
  cancel: 'الغاء',
  Yourscheduletoday: 'جدول أعمالك اليوم.',
  draft: 'مسودة',
  incentives: 'الحوافز',
  allocatedPercentage: 'النسبة المخصصة',
  SalesTeam: 'فريق المبيعات',
  salesPerson: 'موظف المبيعات',
  FreezeAccount: 'تجميد الحساب',
  deleteSalaryComponent: 'حذف تقسيم الراتب',
  salaryComponent: 'مكون الراتب',
  submitted: 'تم الارسال',
  formula: 'نموذج',
  isDefault: 'الافتراضي',
  customerName: 'اسم العميل',
  customerType: 'نوع العميل',
  territory: 'المنطقة',
  customerGroup: 'مجموعة العميل',
  Earnings: 'الارباح',
  ConversationRatio: 'نسبة التحدث',
  abbr: 'الاختصار',
  condition: 'الشرط',
  Refunds: 'المسؤولية',
  ExportReport: 'تقريب إلى عدد صحيح',
  SalesByLocations: 'مبيعات بواسطة الموقع',
  SalesByLocations: 'مبيعات بواسطة الموقع',
  base: 'الاساس',
  totalEarning: 'اجمالي الدخل',
  totalDeduction: 'اجمالي الخصم',
  payrollFrequency: 'تكرار الرواتب',
  variable: 'متغير',
  SalaryStructureAssign: 'تعيين مخطط الراتب',
  UpdateSalaryStructureAssign: 'تحديث تعيين مخطط الراتب',
  AddSalaryStructureAssign: 'اضافة تعيين مخطط الراتب',
  editSalaryComponent: 'تعديل تقسيم الراتب',
  SalaryStructure: 'مخطط الراتب',
  deleteSalaryStructure: 'حذف مخطط الراتب',
  SAR: 'ريال ',
  AddSalaryStructure: 'اضافة مخطط الراتب',
  payrollPayableAccount: 'حساب الراتب المستحق',
  Heresthatshappeningwithyourstoretoday: 'هذا ما يحدث مع الشركة اليوم',
  UpdateSalaryStructure: 'تحديث مخطط الراتب',
  dependsOnPaymentDays: 'تأثيره على ايام الدفع',
  removeIfZeroValued: 'ازالة عندما يكون صفر',
  amountBasedOnFormula: 'مبلغ يتم تقديمه على النموذج',
  roundToTheNearestInteger: 'تقريب إلى عدد صحيح',
  doNotIncludeInTotal: 'لا تشمل في الاجمالي',
  addSalaryComponent: 'اضافة مكون راتب',
  SalaryComponentAbbreviation: 'اختصار عنصر الراتب',
  cancelled: 'تم الغاء',
  settingHealthcare: 'اعدادات الصحة',
  stockBalance: 'رصيد المخزون',
  StockBalanceList: 'قائمة رصيد المخزون',
  StockLedger: 'سجل المخزون',
  isgroup: 'مجموعة',
  user_remark: 'ملاحظات المستخدم',
  total_credit: 'إجمالي الائتمان',
  reject: 'رفض',
  total_debit: 'إجمالي الخصم',
  CostCenterNumber: 'رقم مركز التكلفة',
  parentcostcenter: 'مركز التكلفة الرئيسي',
  cost_center_number: 'رقم مركز التكلفة',
  external: 'خارجي',
  submitJournal: 'تأكيد القيد',
  addCostCenter: 'اضافة مركز التكلفة',
  ENTERPATIENTDETAILS: 'ادخل معلومات المريض',
  suppliersName: 'اسم المورد',
  EDITPATIENTDETAILS: 'تعديل معلومات المريض',
  EmployeeAdvance: 'سلفه أو عهده',
  AddEmployeeAdvance: 'اضافة سلفه أو عهده',
  inPatientItem: 'عنصر الحجز الداخلي',
  accountDetails: 'تفاصيل الحساب',
  advanceAmount: 'مبلغ المستحقات',
  EditEmployeeAdvance: 'تعديل سلفه أو عهده',
  discountPercentage: 'نسبة الخصم',
  ParentCostCenter: 'مركز التكلفة الرئيسي',
  editLandedCostVoucher: 'تعديل فاتورة التكلفة',
  deleteEmployeeAdvance: 'حذف المستندات الخاصة بالموظف',
  CostCenterName: 'اسم مركز التكلفة',
  grossProfit: 'اجمالي الربح',
  quantity: 'الكمية',
  purchaseInvoice: 'فاتورة شراء',
  applicableCharges: 'الرسوم المطبقة',
  editCustomer: 'تعديل العميل',
  totalTaxesAndCharges: 'اجمالي الضرائب والرسوم',
  Delete: 'حذف',
  editSalesOrder: 'تعديل فاتورة بيع',
  Advance: 'مستحقات',
  Amount: 'مبلغ',
  Count: 'عدد',
  Tax: 'ضريبة',
  totalSalesOrder: 'اجمالي الفاتورة',
  totalSalesOrderAmount: 'اجمالي مبلغ الفاتورة',
  totalSalesOrderCount: 'اجمالي عدد الفواتير',
  totalSalesOrderAdvance: 'اجمالي مستحقات الفاتورة',
  totalSalesOrderTax: 'اجمالي ضرائب الفاتورة',
  customerAccounts: 'حسابات العملاء',
  salesOrder: 'فاتورة بيع',
  sales: 'بيع',
  addSalesOrder: 'إضافة طلب مبيعات',
  PurchaseReceipts: 'المستندات الشراء',
  DeletethePurchaseInvoice: 'حذف فاتورة شراء',
  AddPurchaseInvoice: 'اضافة فاتورة شراء',
  DistributeManually: 'توزيع يدويا',
  searchItemCode: 'ابحث عن كود الصنف',
  discountAmount: 'مبلغ الخصم',
  addCustomer: 'اضافة العميل',
  customerNameInArabic: 'اسم العميل بالعربية',
  customerDetails: 'تفاصيل العميل',
  deleteCustomer: 'حذف العميل',
  rate: 'سعر الوحده و الاجمالي',
  payment: 'الدفع',
  receiptVoucher: 'سند قبض',
  creditLimit: 'حد الائتمان',
  next: 'التالي',
  prev: 'السابق',
  canceltheAppointment: 'الغاء الحجز',
  BankTransfer: 'تحويل بنكي',
  addBankTransfer: 'اضافة تحويل بنكي',
  AreyousuretoCancelthisappointment: 'هل انت متاكد من انك تريد الغاء هذا الحجز',
  assetReceivedButNotBilled: 'المستلم بدون فاتورة',
  costCenter: 'مركز التكلفة',
  addReceiptVoucher: 'إضافة سند قبض',
  editReceiptVoucher: 'تعديل فاتورة الاستلام',
  OutstandingAmount: 'المبلغ المستحق',
  ReceiptVoucher: 'سند قبض',
  AddExpenseClaim: 'اضافة مطالبة مصروفات',
  ExpenseClaim: 'مطالبة مصروفات',
  stockAdjustmentAccount: 'حساب التعديل في المخزون',
  amount: 'المبلغ',
  PaymentVoucher: 'سند دفع',
  chartOfAccounts: 'قائمة الحسابات',
  totalSanctionedAmount: 'المبلغ المصدق',
  totalClaimedAmount: 'المبلغ المستحق',
  EditExpenseClaim: 'تعديل مطالبة مصروفات',
  Date: 'التاريخ',
  expenseType: 'نوع المصروفات',
  sanctionedAmount: 'المبلغ المصدق',
  expenseDate: 'تاريخ المصروفات',
  advancePaid: 'الدفعات المقدمه',
  unclaimedAmount: 'المبلغ المستحق',
  advances: 'العهد و السلف بطرف الموظف',
  employeeAdvance: 'العهده أو السلفه',
  autoExchangeRateRevaluation: 'تجديد نسبة الصرف يدويا',
  accountingInfo: 'معلومات المحاسبة',
  additionalDetails: 'تفاصيل اضافية',
  expenses: 'المصروفات',
  capitalWorkInProgressAccount: 'حساب العمليات المستمرة',
  depreciationCostCenter: 'مركز التكلفة للتجزئة',
  disposalAccount: 'حساب الاستهلاك',
  stockReceivedButNotBilled: 'المستلم بدون فاتورة',
  valuationRate: 'سعر التقييم',
  costCenter: 'مركز التكلفة',
  defaultProvisionalAccount: 'حساب التوقيع الافتراضي',
  addRow: 'اضافة صف',
  baseAmount: 'المبلغ الاساسي',
  approvalStatus: 'حالة الموافقة',
  departmentInformation: 'معلومات القسم',
  itemPrice: 'سعر العنصر',
  priceList: 'قائمة السعر',
  currency: 'العملة',
  totalAdvance: ' إجمالي المبلغ المدفوع',
  roundOffCostCenter: 'مركز التكلفة الخاص بالتقريب',
  Item: 'الصنف',
  inWords: 'المجموع كتابه',
  updateStock: 'تحديث المخزون',
  isSubcontracted: 'يتم التعاقد من الباطن',
  useCompanyRoundoffCostCenter: 'استخدام مركز التكلفة الخاص بالشركة',
  sellingCostCenter: 'مركز التكلفة الخاص بالبيع',
  buyingCostCenter: 'مركز التكلفة الخاص بالشراء',
  AddItem: 'اضافة صنف',
  purpose: 'الغرض',
  differenceAmount: 'مبلغ الفرق',
  isStockItem: 'هل هذا الصنف متاح للبيع',
  openingStock: 'المخزون الافتتاحي',
  serviceUnitName: 'اسم وحدة الخدمة',
  valuationRate: 'سعر التقيم',
  itemTaxTemplate: 'قالب الضريبة للصنف',
  standardRate: 'معدل قياسي',
  isFixedAsset: 'هل هذا الصنف موجود في الاصول',
  assetCategory: 'فئة الصنف',
  conversionFactor: 'معامل التحويل',
  uom: 'وحدة القياس',
  discountAccount: 'حساب الخصم',
  minimumNetRate: 'الحد الادنى لسعر الصافي',
  maximumNetRate: 'الحد الاقصى لسعر الصافي',
  isZeroRated: 'هل هذا الصنف مجاني',
  valuationMethod: 'طريقة القياس',
  enableDeferredExpense: 'تفعيل النفقات المؤجله',
  noOfMonthsExp: 'عدد الشهور المتأخرة',
  purchaseUOM: 'وحدة الشراء',
  autoCreateAssets: 'إنشاء الأصول تلقائيًا',
  isGroupedAsset: 'هل هذا الصنف مجموعة',
  allowAppointments: 'السماح بالزيارات',
  inpatientOccupancy: 'المستشفى في الوحدة',
  serviceUnitType: 'نوع وحدة الخدمة',
  defaultReceivableAccount: 'حساب القبض الافتراضي',
  warehouse: 'المستودع',
  purchaseReciept: 'استلام مشتريات',
  editPurchaseReciept: 'تعديل استلام مشتريات',
  defaultEmployeeAdvanceAccount: 'حساب التوقيع الافتراضي',
  addServiceUnit: 'اضافة وحدة الخدمة',
  addPurchaseReciept: 'إضافة استلام مشتريات',
  DeletethePurchaseReciept: 'حذف استلام مشتريات',
  itemGroups: 'مجموعات الخدمات',
  paymentSchedule: 'جدولة الدفعيات',
  parentItemGroup: 'مجموعة الأصناف الرئيسية',
  netTotal: 'المجموع الصافي',
  itemGroup: 'مجموعة الأصناف',
  addItemGroup: 'اضافة مجموعة الخدمات',
  itemGroupName: 'اسم مجموعة الخدمات',
  editItemGroup: 'تعديل مجموعة الخدمات',
  DeleteItem: 'حذف الصنف',
  customItemGroupId: 'معرف المجموعه ',
  includedInPaidAmount: 'مستخدم في المبلغ المدفوع',
  includedInPrintRate: 'مستخدم في سعر الطبقة',
  taxesDetails: 'تفاصيل الضرائب',
  CreationDate: 'تاريخ الانشاء',
  purchaseItem: 'مشتريات الصنف',
  unitofMeasure: 'وحدة القياس',
  salesItem: 'صنف المبيعات',
  taxes: 'الضرائب',
  AvailableSale: 'متاح للبيع',
  NotAvailableSale: 'غير متاح للبيع',
  docType: 'نوع المستند',
  LastModified: 'اخر تعديل',
  modifiedBy: 'تعديل بواسطة',
  defaultDeferredExpenseAccount: 'حساب المصروفات المتأخرة',
  defaultExpenseAccount: 'حساب المصروفات',
  defaultIncomeAccount: 'حساب الدخل',
  writeOffAccount: 'حساب المخصومات',
  defaultDiscountAccount: 'حساب الخصم',
  defaultDeferredRevenueAccount: 'حساب المصروفات المتأخرة',
  unrealizedProfitLossAccount: 'حساب الاستحقاقات والاستثمارات',
  exchangeGainLossAccount: 'حساب الخسارة والربح',
  defaultInTransitWarehouse: 'مستودع الانتقال الافتتاحي',
  depreciationExpenseAccount: 'حساب المصروفات المستلمة الافتتاحي',
  owner: 'المالك',
  defaultExpenseClaimPayableAccount: 'حساب المصروفات المستلمة الافتتاحي',
  notAvailable: 'غير متاح',
  systemInfo: 'معلومات النظام',
  defaultCashAccount: 'حساب النقدي الافتتاحي',
  CanceltheDebitNote: 'الغاء مذكرة الخصم',
  stockReconcillation: 'تسوية المخزون',
  stockEntry: 'دخول المخزون',
  item: 'الصنف',
  defaultInTransitWarehouse: 'مستودع الانتقال الافتتاحي',
  editProfile: 'تعديل الملف الشخصي',
  stockReceivedButNotBilled: 'المخزون المستلم بدون فاتورة',
  details: 'تفاصيل',
  editAccountPeriod: 'تعديل الفترة المحاسبية',
  editModeOfPayment: 'تعديل طريقة الدفع',
  PurchaseInvoice: 'فاتورة شراء',
  defaultInventoryAccount: 'حساب الجرد الافتتاحي',
  inventory: 'الجرد',
  roundOffAccount: 'حساب التقريب',
  maintainStock: 'الصيانة',
  TotalEarning: 'مجموع الدخل',
  Orders: 'الطلبات',
  MyBalance: 'رصيدى',
  Herestthatshappeningwithyourstoretoday: 'هذا ما يحدث مع متجرك اليوم',
  purchaseDetails: 'تفاصيل الشراء',
  salesDetails: 'تفاصيل المبيعات',
  shelfLifeInDays: 'مدة الحفل (باليوم)',
  GoodMorning: 'صباح الخير',
  SeeDetails: 'عرض تفاصيل',
  Revenue: 'الايرادات',
  zatca_payment_means_code: 'كود طريقة الدفع هيبة الزكاه و الضريبه',
  WithdrawMoney: 'سحب المال',
  salesInvoice: 'فاتورة مبيعات',
  street: 'الشارع',
  defaultUOM: 'وحدة القياس الافتتاحية',
  country: 'الدولة',
  EditSalesInvoice: 'تعديل فاتورة المبيعات',
  Numbermustbe15digits: 'الرقم يجب ان يكون 15 رقما',
  ViewAllOrders: 'عرض جميع الطلبات',
  pincode: 'الرمز البريدي',
  AdditionalIds: 'معرفات اضافية',
  please_enter_at_least_one_additional_ids: 'يرجى ادخال على الاقل معرف واحد',
  ViewNetEarnings: 'عرض الايرادات الصافية',
  Numbermuststartwith3: 'الرقم يجب أن يبدأ بـ 3',
  Numbermustendwith3: 'الرقم يجب أن ينتهي بـ 3',
  Customers: 'العملاء',
  AddProduct: 'إضافة صنف',
  receivedQty: 'الكمية المستلمة',
  CreateDownPaymentInvoice: 'اضافة فاتورة مدفوعة',
  CreateFullPaymentInvoice: 'اضافة فاتورة مكلفة',
  GetPaymentEntryDetails: 'تفاصيل دفع',
  PaymentMethod: 'طريقة الدفع',
  holidaylist: 'قائمة العطلات',
  inventoryDetails: 'تفاصيل الجرد',
  salse: 'البيع',
  accounts: 'الحسابات',
  purchasing: 'الشراء',
  itemDefaults: 'تفاصيل الصنف',
  TaxesandCharges: 'الضرائب والرسوم',
  patientNationality: 'جنسية المريض',
  Tabby: 'تابي',
  Tamara: 'تامارا',
  cash: 'كاش',
  level: 'مستوى',
  yearOfPassing: 'سنة الخروج',
  salary: 'الرواتب',
  totalExperience: 'مجموع الخبرة',
  passportNumber: 'رقم جواز السفر',
  qualification: 'المؤهل',
  relievingDate: 'تاريخ الخروج',
  ValidUpto: 'صالح حتى',
  reasonForLeaving: 'سبب الخروج',
  schoolUniv: 'المدرسة / الجامعة',
  bankName: 'اسم البنك',
  maritalStatus: 'الحالة الاجتماعية',
  SalaryMode: 'طريقة الرواتب',
  payrollCostCenter: 'مركز تكلفة الرواتب',
  deletetheDiagnosis: 'حذف التشخيص',
  SearchByDiagnosis: 'البحث عن التشخيص',
  deletePayorContract: 'حذف الاتفاقية الدفع',
  AddPayorContract: 'اضافة الاتفاقية الدفع',
  SearchPayorContract: 'بحث عن الاتفاقية الدفع',
  view: 'عرض',
  show: 'عرض',
  PayorContract: 'اتفاقية الدفع',
  SearchPatientInsurancePolicy: 'بحث عن بوليصة التأمين',
  searchEligibilityPlan: 'البحث عن خطة التأهيل',
  ReferringPractitioner: 'الطبيب المشير',
  SalesInvoiceInformation: 'معلومات فاتورة مبيعات',
  ENTERSALESINVOICEINFORMATION: 'ادخل معلومات فاتورة مبيعات',
  includeItemInManufacturing: 'تضمين العنصر في الصيانة',
  ReviewDetails: 'تفاصيل المراجعة',
  paymentDueDate: 'تاريخ الدفع',
  Insurances: 'التأمينات',
  totalQty: 'الكمية الكلية',
  Category: 'الفئة',
  deleteLandedCostVoucher: 'حذف فاتورة المصروفات',
  LandedCostVoucher: 'فاتورة المصروفات',
  addDeductTax: 'إضافة/خصم الضريبه',
  chargeType: 'نوع الرسوم',
  TotalTaxesandCharges: 'الضرائب والرسوم الكلية',
  SubmitSalesInvoice: 'تأكيد فاتورة مبيعات',
  enterEncounterInformation: 'ادخال معلومات الحجز',
  AddSalesInvoice: 'اضافة فاتورة مبيعات',
  encounterInformation: 'معلومات الحجز',
  rounding: 'تقريب',
  allocateOnDay: 'اضافة الرصيد في:',
  firstDay: 'اليوم الاول',
  encounterimpression: 'مراجعة الحجز',
  lastDay: 'اليوم الاخير',
  earnedLeaveFrequency: 'اضافة للرصيد بشكل',
  items: 'العناصر',
  includeHoliday: 'تضمين العطل',
  isEarnedLeave: 'التكليف السنوي',
  baseDiscountAmount: 'مبلغ الخصم الاساسي',
  additionalDiscountPercentage: 'نسبة خصم اضافية',
  disableRoundedTotal: 'تعطيل التقريب',
  applyDiscountOn: 'تطبيق الخصم على',
  roundingAdjustment: 'مبلغ التقريب',
  roundedTotal: 'المجموع الاساسي بالتقريب',
  baseRoundedTotal: 'المجموع الاساسي بتقريب',
  grandTotal: 'المجموع مع الضريبه',
  select_invoice: 'حدد الفاتورة',
  Party: 'الجهة',
  SalesOrder: 'طلب البيع',
  reviewDetails: 'تفاصيل المراجعة',
  companyName: 'اسم الشركة',
  companyNameInArabic: 'اسم الشركة بالعربية',
  appointment: 'ميعاد',
  abbr: 'الاختصار',
  Name: 'الاسم',
  addressName: 'اسم العنوان',
  noOfMonthsOfExpense: 'عدد اشهر المصاريف',
  profile: 'الملف الشخصي',
  EditAccountDetails: 'تعديل معلومات الحساب',
  addressDetails: 'معلومات العنوان',
  supplier_primary_address: 'العنوان الرئيسي للمورد',
  customer_primary_address: 'العنوان الرئيسي للعميل',
  zatcaInvoiceType: 'Zatca نوع الفاتورة ',
  CanceltheSalesInvoice: 'إلغاء الفاتورة',
  cancelthePaymentEntry: 'إلغاء المدفوعات',
  AreyousuretoCancelthisPaymentEntry: 'هل انت متاكد من إلغاء هذه المدفوعات؟',
  AreyousuretoCancelthisSalesInvoice: 'هل انت متاكد من إلغاء هذه الفاتورة؟',
  groupForLedger: 'تغير الي حساب',
  ledgerToGroup: 'تغير الي حساب',
  canceltheEncounter: 'إلغاء الحجز',
  salesSettings: 'اعدادات المبيعات',
  accountSettings: 'اعدادات الحسابات',
  inventorySettings: 'اعدادات المخزون',
  additionalSettings: 'اعدادات اضافية',
  autoErrFrequency: 'تكرار التحقق التلقائي',
  crNumber: 'رقم السجل التجاري',
  defaultHolidayList: 'قائمة العطلات ',
  fixedAssetsSettings: 'اعدادات المستودعات',
  CompanyInformation: 'معلومات الشركة',
  groupToLedger: 'تغير الي مجموعة',
  AreyousuretoCancelthisEncounter: 'هل انت متاكد من إلغاء هذا الحجز؟',
  export: 'تصدير',
  PaidAmount: 'المبلغ المدفوع',
  default_receivable_account: 'حساب القبض الافتراضي',
  defaultBankAccount: 'حساب البنك الافتراضي',
  companyDescription: 'وصف الشركة',
  monthlySalesTarget: 'هدف المبيعات الشهرية',
  enableProvisionalAccountingForNonStockItems:
    'تمكين الحساب المستمر للعناصر الغير المخزونية',
  FixedAssetSettings: 'اعدادات المستودعات',
  creditLimit: 'حد الائتمان',
  autoExchangeRateRevaluation: 'إعادة تقييم سعر الصرف التلقائي',
  SeriesForDepreciationEntry: 'سلسلة لإدخال الإهلاك',
  enablePerpetualInventory: 'تمكين المخزون المستمر',
  customAdvancePaymentAccount: 'حساب الدفعة المقدمة المخصصة',
  allowAccountCreationAgainstChildCompany:
    'السماح بانشاء حسابات للشركات الفرعية',
  defaultPayableAccount: 'حساب القبض الافتراضي',
  StockSettings: 'اعدادات المخزون',

  defaultExpenseClaimPayableAccount:
    'الحساب المستحق الدفع لمطالبة المصروفات الافتراضية',
  AccountsSettings: 'إعدادات الحسابات',
  HRPayrollSettings: 'إعدادات الموارد البشرية وكشوف المرتبات',
  customDefaultDownPaymentItem: 'عنصر الدفعة المقدمة الافتراضية المخصصة',
  totalMonthlySales: 'إجمالي المبيعات الشهرية',
  website: 'الموقع الالكتروني',
  deleteAccount: 'حذف الحساب',
  Allocated: 'تخصيص',
  BuyingSellingSettings: 'اعدادات الشراء والبيع',
  isZeroRated: 'التكليف السنوي',
  editAppointment: 'تعديل الميعاد',
  customCrNumber: 'رقم الفاتورة المخصص',
  TrialBalance: 'الرصيد المحاسبي',
  isExempt: 'التعويض',
  receivedStockQty: 'الكمية المستلمة',
  fgItemQty: 'الكمية النهائية',
  DeletetheAppointmentDuration: 'حذف مدة الميعاد',
  AccountingEntries: 'مداخيل محاسبيه',
  Duning: 'تذكير بالدفع',
  SearchFiscalYear: 'بحث عن سنة المالية',
  deferredExpenseAccount: 'حساب المصاريف المستحقة',
  DeletetheModeofFiscalYear: 'حذف نوع السنة المالية',
  JournalEntry: 'قيد اليومية',
  List: 'قائمة',
  Tree: 'شجرة',
  addJournalEntry: 'اضافة قيد يومية',
  DeletetheGeneralLedger: 'حذف قيد العام',
  ReferenceNumber: 'رقم المرجع',
  ReferenceDate: 'تاريخ المرجع',
  searchJournalEntry: 'بحث عن اسم الحزب',
  Outstanding: 'متبقي',
  InvoiceNumber: 'رقم الفاتورة',
  PaymentReferences: 'تخصيص الدفعه',
  ENTERJOURNALENTRYINFORMATION: 'ادخال معلومات القيد اليومي',
  JournalEntryInformation: 'معلومات القيد اليومي',
  EntryType: 'نوع القيد',
  ChequeReferenceNo: 'رقم الشيك/المرجع',
  ChequeReferenceDate: 'تاريخ الشيك/المرجع',
  symptoms: 'الاعراض',
  InvoiceDetails: 'تفاصيل الفاتورة',
  AccountCurrencyTo: 'عملة الحساب (إلى)',
  AccountPaidTo: 'الحساب المدفوع الي',
  diagnosis: 'التشخيص',
  AccountCurrencyFrom: 'عملة الحساب (من)',
  AccountPaidFrom: 'الحساب المدفوع من',
  labTest: 'فحص',
  labTestName: 'اسم الاختبار',
  PartyBalance: 'رصيد الجهة',
  message: 'الرسالة',
  addLabTest: 'اضافة فحص',
  Materials: 'مواد',
  zatcaDetails: 'تفاصيل ZATCA',
  searchMaterialName: 'بحث عن اسم المواد',
  DentalMaterial: 'مواد الاسنان',
  addLeaveApplication: 'اضافة طلب إجازه',
  LeaveApplication: 'طلب إجازه',
  DeleteLeaveApplication: 'حذف طلب إجازه',
  Employee: 'موظف',
  employeeLab: 'موظف (محاسبة)',
  Encounters: 'الحجوزات',
  salesInvoiceCredit: 'فاتورة مبيعات (استحقاق)',
  AddSalesInvoiceCredit: 'اضافة فاتورة مبيعات (استحقاق)',
  creditNote: 'ملاحظات',
  zatcaStatus: 'حالة ZATCA',
  company_address: 'عنوان الشركة',
  custom_return_reason: 'سبب استرجاع',
  reference_name: 'اسم المرجع',
  addEncounter: 'اضافة حجز',
  return_against: 'استرجاع',
  halfDay: 'نصف يوم',
  reference_type: 'نوع المرجع',
  integration_status: 'حالة التكامل',
  leaveBalance: 'تخصيصات المرتبات',
  totalLeaveDays: 'اجمالي عدد الاجازات',
  GetLinkedPayments: 'احصل على الدفعات المتصلة',
  FromDate: 'من تاريخ',
  ToDate: 'الي تاريخ',
  leavesAllocated: 'تخصيصات',
  LinkedPayments: 'الدفعات المتصلة',
  showRemarks: 'اظهار الملاحظات',
  newLeavesAllocated: 'الأيام المخصصه للموظف',
  carryForward: 'نقل الارصده الغير مستخدمه',
  carryForwardedLeavesCount: 'تخصيصات متبقية',
  expired: 'منتهية',
  unusedLeaves: 'الإجازات غير المستخدمة',
  totalLeavesEncashed: 'الإجازات الكلية',
  openingStock: 'المخزون الافتتاحي',
  addGeneralLedger: 'اضافة دفتر اليومية',
  editGeneralLedger: 'تعديل دفتر اليومية',
  CreateModeOfPayment: 'اضافة نوع الدفع',
  AccountType: 'نوع الحساب',
  AccountCurrency: 'عملة الحساب',
  editPurchaseInvoice: 'تعديل فاتورة المشتريات',
  AddReceipt: 'اضافة استلام',
  StockReconcillation: 'تسوية المخزون',
  AddStockReconcillation: 'اضافة تسوية المخزون',
  EditStockReconcillation: 'تعديل تسوية المخزون',
  AddInvoice: 'اضافة فاتورة',
  reportType: 'نوع التقرير',
  ModeofPaymentInformation: 'معلومات نوع الدفع',
  AccountName: 'اسم الحساب',
  percentage: 'النسبة المئوية',
  remarks: 'ملاحظات',
  Account: 'الحساب',
  plusRiyal: '+ ريال',
  EditChartAccount: 'تعديل جدول الحسابات',
  account: 'حساب',
  AddAccount: 'اضافة حساب',
  yes: 'نعم',
  RootType: 'نوع الجذر',
  no: 'لا',
  Bank: 'بنك',
  Entermodeofpaymentinformation: 'ادخال معلومات نوع الدفع',
  SearchAccountName: 'بحث عن حساب الاسم',
  country: 'الدولة',
  ChartAccount: 'جدول الحسابات',
  AddModeOfPayment: 'اضافة نوع الدفع',
  serviceUnits: 'وحدات الخدمة',
  ENTERFISCALYEARINFORMATION: 'ادخال معلومات السنة المالية',
  ENTERSERVICEUNITINFORMATION: 'ادخال معلومات الوحدة الخدمية',
  TIMELINE: 'الخط الزمني',
  WEEKLYVISITORS: 'الزيارات الأسبوعية',
  PRODUCTSUMMARY: 'ملخص المنتجات',
  COUNTRYSTATISTICS: 'احصائيات الدول',
  PartyType: 'نوع الجهة',
  searchSalesInvoice: 'بحث عن فاتورة المبيعات',
  TotalTaxesandCharges: 'مجموع الضرائب والرسوم',
  GrandTotal: 'المجموع شامل الضرائب',
  SALESACTIVITY: 'نشاط المبيعات',
  or: 'أو',
  id: 'الرقم',
  expenseType: 'نوع المصروفات',
  EditExpenseClaim: 'تعديل طلب المصروف',
  AddLandedCostVoucher: 'إضافة مصاريف شحن و تفريغ',
  DefaultAccount: 'الحساب الافتراضي',
  Finance: 'مالية',
  ENTERMATERIALINFORMATION: 'ادخال معلومات المادة',
  paymentEntry: 'إدخال الدفع',
  EndDate: 'تاريخ النهاية',
  numberOfEmployees: 'عدد الموظفين',
  EditPayrollEntry: 'تعديل أدخال الراتب',
  CreateSalarySlips: 'اضافة سلايس الراتب',
  SubmitSalarySlips: 'ارسال سلايس الراتب',
  YearEndDate: 'تاريخ نهاية العام',
  journal: 'دفتر اليومية',
  DeletetheSalesInvoice: 'حذف فاتورة المبيعات',
  MAINTASKS: 'المهام الرئيسية',
  SubmittheSalesInvoice: 'ارسال فاتورة المبيعات',
  SubmitthePaymentEntry: 'ارسال أدخال الدفع',
  YearStartDate: 'تاريخ بدء العام',
  FiscalYears: 'السنوات المالية',
  ENTERDEPARTMENTINFORMATION: 'ادخال معلومات القسم',
  ENTERPractitionerScheduleFORMATION: 'ادخال معلومات جدولة المواعيد',
  FiscalYear: 'السنة المالية',
  addNewItem: 'اضافة عنصر جديد',
  PaymentType: 'نوع الدفع',
  AddFiscalYear: 'اضافة سنة مالية',
  Processing: 'تحميل',
  Pay: 'دفع',
  Yes: 'نعم',
  SessionTime: 'وقت الجلسة',
  time_slots: 'المواعيد',
  schedule_name: 'اسم الجدول',
  No: 'لا',
  AddChartAccount: 'اضافة حساب جدولي',
  EditAdditionalSalay: 'تعديل خصومات و اضافة راتب',
  payrollDate: 'تاريخ الراتب',
  overwriteSalaryStructureAmount: 'حذف الخصومات و الاضافاة السابقه لنفس البند',
  RECENTTRANSACTIONS: 'المعاملات الحديثة',
  salaryComponent: 'مكونات الراتب',
  ParentAccount: 'الحساب الرئيسي',
  AddAdditionalSalay: 'اضافة خصومات و اضافة راتب',
  deleteAdditionalSalay: 'حذف خصومات و اضافة راتب',
  AdditionalSalay: 'خصومات و اضافة راتب',
  InternalTransfer: 'تحويل داخلي',
  ModeofPayment: 'نوع الدفع',
  type: 'type',
  absentDays: 'ايام الغياب',
  leaveWithoutPay: 'غياب بدون دفع',
  totalWorkingDays: 'مجموع الايام العملية',
  generalLedger: 'دفتر اليومية',
  ReportType: 'نوع التقرير',
  General: 'تحويل داخلي',
  RootType: 'نوع الجذر',
  topItems: 'الصنفات الرئيسيين',
  Customer: 'العميل',
  CountSalesOrder: 'عدد طلبات المبيعات',
  topCustomers: 'افضل العملاء',
  AccountInformation: 'معلومات الحساب',
  AccountNumber: 'رقم الحساب',
  Last5Encounter: 'اخر 5 حجوزات',
  Last5Invoices: 'اخر 5 فواتير',
  addPaymentMethod: 'اضافة طريقة الدفع',
  EditPaymentMethod: 'تعديل طريقة الدفع',
  EditCostCenter: 'تعديل نظام التكلفة',
  AddItemPrice: 'اضافة سعر الصنف',
  EditBNPI: 'تعديل طرق السداد',
  DeletetheBNPI: 'حذف طرق السداد',
  confirmDelete: 'تأكيد الحذف',
  editDiagnosis: 'تعديل التشخيص',
  itemDetails: 'تفاصيل الصنف',
  disabled: 'معطل',
  DeletetheAddress: 'حذف العنوان',
  isRecurring: 'تكرار لأكثر من راتب',
  priceListCurrency: 'عملة قائمة التسعير',
  supplierName: 'اسم المورد',
  purchaseOrder: 'طلب الشراء',
  DeletetheCostCenter: 'حذف نظام التكلفة',
  GroupAccount: 'مجموعة حسابات',
  Supplier: 'المورد',
  buyingPriceList: 'قائمة التسعير الشراء',
  plcConversionRate: 'سعر التحويل plc',
  addPurchaseOrder: 'اضافة طلب الشراء',
  editPurchaseOrder: 'تعديل طلب الشراء',
  conversionRate: 'سعر التحويل',
  editMaterialRequest: 'تعديل طلب مواد',
  Shareholder: 'المساهم',
  MaterialRequest: 'طلب مواد',
  addMaterialRequest: 'اضافة طلب مواد',
  Receive: 'استلام',
  Pleaseinputaninteger: 'الرجاء ادخال عدد صحيح',
  distributeChargesBasedOn: 'توزيع الرسوم بناء على',
  expenseAccount: 'حساب المصروف',
  incomeAccount: 'حساب الدخل',
  AddBNPI: 'اضافة طرق السداد',
  collectionmethod: ' طرق السداد',
  searchByName: 'بحث عن الاسم',
  enableDeferredRevenue: 'تفعيل إيرادات مؤجله',
  Deletethepaymententry: 'حذف أدخال الدفع',
  searchServiceUnitName: 'بحث عن وحدة الخدمة الاسم',
  searchEncounter: 'بحث عن حجز',
  itemName: 'اسم الصنف',
  editPaymentEntry: 'تعديل أدخال الدفع',
  addPaymentEntry: 'إضافة إدخال الدفع',
  inventoryInformation: 'معلومات المخزون',
  ENTERINVENTORYINFORMATION: 'ادخال معلومات المخزون',
  searchPartyName: 'بحث الحزب',
  PaymentEntryInformation: 'معلومات أدخال الدفع',
  ENTERPAYMENTENTRYINFORMATION: 'ادخال معلومات أدخال الدفع',
  AccountHead: 'رأس الحساب',
  Total: 'المجموع قبل الضريبه',
  type: 'النوع',
  TaxRate: 'معدل الضريبة',
  DeletetheMaterial: 'حذف المادة',
  TaxAmount: 'مبلغ الضريبة',
  DeletetheDepartment: 'حذف القسم',
  DeletetheServiceUnit: 'حذف وحدة الخدمة',
  shelfLifeInDays: 'فترة الصلاحية في الأيام',
  price: 'السعر',
  unitofMeasure: 'وحدة القياس',
  materialName: 'اسم المادة',
  comment: 'تعليق',
  medicalCoding: 'ترميز الطبية',
  AllocatedTo: 'تعيين ل',
  medicalCode: 'الكود الطبي',
  AssignedBy: 'تعيين بواسطة',
  AssignedByFullName: 'تعيين بواسطة الاسم الكامل',
  medicalCodeStandard: 'الكود الطبي الاساسي',
  code: 'الكود',
  description: 'الوصف',
  addLeavePolicyAssign: 'اضافة سياسة إجازات لموظف',
  leavePolicyAssign: 'تعيين السياسة',
  worksheetPrint: 'طباعة ورقة العمل',
  resultLegendPrint: 'طباعة أسطورة النتيجة',
  ReferenceName: 'اسم المرجع',
  ReferenceType: 'نوع المرجع',
  printPosition: 'موضع الطباعة',
  resultLegend: 'أسطورة النتيجة',

  outPatient: 'مريض خارجي',
  patientAge: 'عمر المريض',
  sampleLab: 'تحضير مختبر',
  searchPatient: 'بحث عن مريض',
  practitionerSchedule: 'مواعيد الطبيب',
  appointmentType: 'مدة الزياره',
  serviceUnit: 'اسم العياده',
  inPatientVisit: 'زيارة المريض الداخلية',
  practitionerType: 'نوع الطبيب',
  requireCountry: 'الرجاء ادخال الدولة',
  requiredFirstName: 'الرجاء ادخال الاسم الاول',
  requiredMiddleName: 'الرجاء ادخال الاسم الوسط',
  requireMaritalStatus: 'الرجاء ادخال الحالة الزوجية',
  requiredLastName: 'الرجاء ادخال الاسم الاخير',
  requiredAge: 'الرجاء ادخال العمر',
  requiredGender: 'الرجاء ادخال النوع',
  requiredAccountDetails: 'الرجاء ادخال تفاصيل الحساب',
  requiredOccupation: 'الرجاء ادخال الوظيفة',
  requiredBloodGroup: 'الرجاء ادخال فصيلة الدم',
  requireIdentificationNumber: 'الرجاء ادخال رقم الهوية',
  requiredImage: 'الرجاء ادخال الصورة',
  requiredInPatientItem: 'الرجاء ادخال مريض داخلي',
  requiredOutPatient: 'الرجاء ادخال مريض خارجي',
  requiredDate: 'الرجاء ادخال تاريخ الميلاد ',
  Phone: 'رقم الجوال',
  requiredMobile: 'الرجاء ادخال رقم الجوال',
  requiredEmail: 'البريد الالكتروني مطلوب',
  requiredPrintLanguage: 'الرجاء ادخال طباعة اللغة',
  requiredPhoneNumber: 'رقم الهاتف مطلوب',
  requiredDepartment: 'الرجاء ادخال القسم',
  requiredAddress: 'العنوان مطلوب',
  officePhone: 'هاتف المكتب',
  companySettings: 'اعدادات الشركة',
  downPaymentItem: 'مريض داخلي',
  advancePaymentAccount: 'حساب الدفع المسبق',
  requiredAppointmentType: 'الرجاء ادخال مدة الزياره',
  requiredInPatientVisit: 'الرجاء ادخال زيارة المريض الداخلية',
  requiredReports: 'الرجاء ادخال تفضيل التقارير',
  requiredOutPatientCharge: 'الرجاء ادخال مريض خارجي',
  requiredCity: 'المدينة مطلوبة',
  requiredPractitionerSchedule: 'الرجاء ادخال جدول الطبيب',
  requiredAppointmentTime: 'الرجاء ادخال وقت الزيارة',
  requiredAppointmentDate: 'الرجاء ادخال تاريخ الزيارة',
  requiredPractitioner: 'الرجاء ادخال الطبيب',
  requiredPractitionerName: 'الرجاء ادخال اسم الطبيب',
  claimAmount: 'مبلغ الطلب',
  requiredPractitionerNo: 'الرجاء ادخال رقم الطبيب',
  requiredAppointment: 'الرجاء ادخال ميعاد الزيارة',
  requiredMedicalDepartment: 'الرجاء ادخال القسم الطبي',
  requiredStatus: 'الرجاء ادخال الحالة',
  requiredpatientFileNumber: 'الرجاء ادخال رقم ملف المريض',
  requiredPatientName: 'الرجاء ادخال اسم المريض',
  requiredPatientAge: 'الرجاء ادخال العمر',
  requiredSymptoms: 'الرجاء ادخال المرض',
  requiredPatientCareType: 'الرجاء ادخال نوع الرعاية',
  requiredDiagnosis: 'الرجاء ادخال الشك',
  requiredServiceUnit: 'الرجاء ادخال وحدة الخدمة',
  requiredWarehouse: 'الرجاء ادخال المستودع',
  requiredItemGroup: 'الرجاء ادخال مجموعة البنود',
  requiredTestTemplate: 'الرجاء ادخال نموذج الاختبار',
  requiredEmployeeLab: 'الرجاء ادخال مكتب الموظفين',
  toDateGreaterThanFromDate: 'تاريخ الانتهاء يجب ان يكون بعد تاريخ البدء',
};
